import React from 'react';
import { Link } from 'react-router-dom';
import { SiteContainer, Flex, FlexItem, Wrapper } from 'core/layout';
import { Heading, Card, Hairline, Anchor, GoogleMap, Button, BreadcrumbsConnected } from 'elements';
import { FeedbackForm } from 'modules';
import { RawContent } from 'elements/util';
import tulkojumi from 'utils/tulkojumi';
import pathWithRewrite from 'utils/pathWithRewrite';
import {
  StyledContent,
  Small,
  StyledTop,
  CardItem,
  MapsGroup,
  LinkItem,
  StyledTable,
  StyledMap,
  MainHalf,
  FormGroup,
  HideWhenPrint,
} from './styled';





class Kontakti extends React.PureComponent {
  _getPathRewriteProps = (post) => {
    const rewrite = pathWithRewrite(post);
    return {
      link: rewrite.location,
      target: rewrite.target,
    };
  }

  render() {
    const props = this.props

    let acf = {}
    let teksti = {}

    if (props.content.acf) {
      acf = JSON.parse(props.content.acf)
    }

    if (props.teksti) {
      teksti = props.teksti
    }

    return (<SiteContainer>

      <BreadcrumbsConnected
        lang={props.lang}
        path={props.init_page.path}
      />

      <Wrapper>
        <MainHalf>

          <Heading>
            {props.init_page.title}
          </Heading>

          <StyledTop>
            <Flex wrap="true">
              {acf.kontakti ? acf.kontakti.map((kontakts, index) =>
                (<LinkItem basis={1 / 2} width="50%" key={index}>
                  <Heading level={3}>
                    <Anchor href={kontakts.value.replace(/\s/g, '').indexOf('@') > 0 ? `mailto:${kontakts.value.replace(/\s/g, '')}` : `tel:${kontakts.value.replace(/\s/g, '')}`}>
                      {kontakts.value}
                    </Anchor>
                  </Heading>
                  <Small>
                    {kontakts.nosaukums}
                  </Small>
                </LinkItem>)) : null}
            </Flex>
          </StyledTop>
          <Flex column>
            {props.content.relationship_pages ? props.content.relationship_pages.map((post, index) =>
              (<CardItem key={index} style={{ flex: '0 0 auto' }}>
                <Card type="link" title={post.title} {...this._getPathRewriteProps(post) } />
              </CardItem>)) : null}
          </Flex>
        </MainHalf>

        <HideWhenPrint>
          <Hairline main="true" />
        </HideWhenPrint>

        <StyledContent width={1 / 2}>
          <Heading level={3}>
            {acf.subtitle}
          </Heading>
          <MapsGroup>
            <FlexItem>
              <StyledTable>
                <RawContent content={props.content.content} />
              </StyledTable>
            </FlexItem>
            <FlexItem>
              <StyledMap>
                <GoogleMap zoom={16} coordinates={acf.map} />
              </StyledMap>
            </FlexItem>
          </MapsGroup>
        </StyledContent>

        <HideWhenPrint>
          <Hairline main="true" />
        </HideWhenPrint>

        <Flex>
          <FormGroup>
            <FeedbackForm teksti={teksti} />
          </FormGroup>
        </Flex>

      </Wrapper>
    </SiteContainer>)
  }
}

export default Kontakti



// WEBPACK FOOTER //
// ./src/pages/Kontakti/Kontakti.jsx